import aa from 'search-insights';

// Initialize Algolia Insights
// Make sure your environment variables are set in your build system
// REACT_APP_ALGOLIA_APP_ID and REACT_APP_ALGOLIA_SEARCH_API_KEY

aa('init', {
  appId: process.env.REACT_APP_ALGOLIA_APPLICATION_ID,
  apiKey: process.env.REACT_APP_ALGOLIA_API_KEY,
});



// AlgoliaEventManager will store user info from Redux
let reduxUserInfo = null;
let reduxIsLoggedIn = false;

// function getUserToken() {
//   if (reduxIsLoggedIn && reduxUserInfo && reduxUserInfo.id) {
//     return String(reduxUserInfo.id); // Ensure userToken is always a string
//   }
//   return 'anon_user';
// }

// REPLACE the getUserToken function:
function getUserToken() {
  if (reduxIsLoggedIn && reduxUserInfo && reduxUserInfo.id) {
    return String(reduxUserInfo.id);
  }
  // Generate persistent anonymous token
  let anonToken = localStorage.getItem('algolia_anon_token');
  if (!anonToken) {
    anonToken = 'anon_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('algolia_anon_token', anonToken);
  }
  return anonToken;
}


class AlgoliaEventManager {

  static getUserToken() {
      return getUserToken();
  }

  // Set user token and profile in Algolia
  static setAlgoliaUserProfile() {
      const userToken = getUserToken();
      aa('setAuthenticatedUserToken', userToken);
      
      if (reduxIsLoggedIn && reduxUserInfo && reduxUserInfo.id) {
        aa('setUserProfile', {
          userID: String(reduxUserInfo.id),
          email: reduxUserInfo.email || '',
          name: `${reduxUserInfo.firstname || ''} ${reduxUserInfo.lastname || ''}`.trim(),
          company: reduxUserInfo.company || '',
          phone: reduxUserInfo.phone || '',
        });
      } else {
        // Set profile for anonymous users
        aa('setUserProfile', {
          userID: userToken,
          email: '',
          name: 'Anonymous User',
        });
      }
  }
  // Set your index name here or use env variable
  static index = process.env.REACT_APP_ALGOLIA_INDEX || 'shopify_products';

  // Call this in your app after getting user info from Redux
  static setUserInfo({ isLoggedIn, allUserInfo }) {
    reduxIsLoggedIn = isLoggedIn;
    reduxUserInfo = allUserInfo;
  }

  /**
   * Send a view event to Algolia
   * @param {string} eventName - Name of the event
   * @param {string[]} objectIDs - Array of object IDs
   * @param {object} extraData - Additional event data
   */
  static sendView(eventName, objectIDs, extraData = {}) {
    AlgoliaEventManager.setAlgoliaUserProfile();
    const userToken = getUserToken();
    aa('viewedObjectIDs', {
      eventName,
      index: AlgoliaEventManager.index,
      objectIDs,
      userToken,
      ...extraData,
    });
  }

  /**
   * Send a click event to Algolia
   * @param {string} eventName - Name of the event
   * @param {string[]} objectIDs - Array of object IDs
   * @param {object} extraData - Additional event data
   */
  static sendClick(eventName, objectIDs, extraData = {}) {
    AlgoliaEventManager.setAlgoliaUserProfile();
    const userToken = getUserToken();
    aa('clickedObjectIDs', {
      eventName,
      index: AlgoliaEventManager.index,
      objectIDs,
      userToken,
      ...extraData,
    });
  }

  /**
   * Send a conversion event to Algolia
   * @param {string} eventName - Name of the event
   * @param {string[]} objectIDs - Array of object IDs
   * @param {object} extraData - Additional event data
   */
  static sendConversion(eventName, objectIDs, extraData = {}) {
    AlgoliaEventManager.setAlgoliaUserProfile();
    const userToken = getUserToken();
    aa('convertedObjectIDs', {
      eventName,
      index: AlgoliaEventManager.index,
      objectIDs,
      userToken,
      ...extraData,
    });
  }

   /**
   * Send an add-to-cart event to Algolia (after search)
   * @param {string} eventName - Name of the event
   * @param {string[]} objectIDs - Array of object IDs
   * @param {object} extraData - Additional event data
   */
  static addedToCartObjectIDsAfterSearch(eventName, objectIDs, extraData = {}) {
    AlgoliaEventManager.setAlgoliaUserProfile();
    const userToken = getUserToken();
    aa('addedToCartObjectIDsAfterSearch', {
      userToken,
      eventName,
      index: AlgoliaEventManager.index,
      objectIDs,
      eventSubtype: extraData.eventSubtype || 'addToCart', // ADD THIS
      ...extraData,
    });
  }

  /**
   * Send a convertedObjectIDsAfterSearch event to Algolia
   */
  static convertedObjectIDsAfterSearch(eventName, objectIDs, extraData = {}) {
    AlgoliaEventManager.setAlgoliaUserProfile();
    const userToken = getUserToken();
    aa('convertedObjectIDsAfterSearch', {
      userToken,
      eventName,
      index: AlgoliaEventManager.index,
      objectIDs,
      eventSubtype: extraData.eventSubtype || 'purchase', // ADD THIS
      ...extraData,
    });
  }

  /**
   * Send an addedToCartObjectIDs event to Algolia
   */
  static addedToCartObjectIDs(eventName, objectIDs, extraData = {}) {
    AlgoliaEventManager.setAlgoliaUserProfile();
    const userToken = getUserToken();
    aa('addedToCartObjectIDs', {
      userToken,
      eventName,
      index: AlgoliaEventManager.index,
      objectIDs,
      eventSubtype: extraData.eventSubtype || 'addToCart', // ADD THIS
      ...extraData,
    });
  }

  /**
   * Send a clickedObjectIDsAfterSearch event to Algolia
   */
  static clickedObjectIDsAfterSearch(eventName, objectIDs, extraData = {}) {
    AlgoliaEventManager.setAlgoliaUserProfile();
    const userToken = getUserToken();
    aa('clickedObjectIDsAfterSearch', {
      userToken,
      eventName,
      index: AlgoliaEventManager.index,
      objectIDs,
      ...extraData,
    });
  }
}

// ADD: Make AlgoliaEventManager globally accessible
if (typeof window !== 'undefined') {
  window.AlgoliaEventManager = AlgoliaEventManager;
}

export default AlgoliaEventManager;
